import { levelAchieved } from '../../utils/levelAchieved.js'
import { filterItemIdsToSeeds } from '../../utils/filterItemIdsToSeeds.js'
import { getPriceEventForCrop } from '../../utils/getPriceEventForCrop.js'
import { getRandomUnlockedCrop } from '../../utils/getRandomUnlockedCrop.js'
import { getLevelEntitlements } from '../../utils/getLevelEntitlements.js'
import { PRICE_EVENT_CHANCE } from '../../constants.js'
import { PRICE_CRASH, PRICE_SURGE } from '../../templates.js'
import { random } from '../../common/utils.js'
import { randomStream } from '../../enums.js'

import { createPriceEvent } from './createPriceEvent.js'

const TYPE_CRASH = 'priceCrashes'
const TYPE_SURGE = 'priceSurges'

export const generatePriceEvents = (state: farmhand.state): farmhand.state => {
  const priceCrashes = { ...state.priceCrashes }
  const priceSurges = { ...state.priceSurges }
  let newDayNotifications = [...state.newDayNotifications]
  let priceEvent

  // TODO: Use isRandomNumberLessThan here once it supports an exclusive
  // less-than check.
  if (random(randomStream.PRICE_EVENT_CHANCE) < PRICE_EVENT_CHANCE) {
    const { items: unlockedItems } = getLevelEntitlements(
      levelAchieved(state.experience)
    )

    const cropItem = getRandomUnlockedCrop(
      filterItemIdsToSeeds(Object.keys(unlockedItems)),
      randomStream.PRICE_EVENT_CROP
    )
    const { id } = cropItem

    const doesPriceEventAlreadyExist = Boolean(
      priceCrashes[id] || priceSurges[id]
    )

    if (!doesPriceEventAlreadyExist) {
      const priceEventType =
        random(randomStream.PRICE_EVENT_TYPE) < 0.5 ? TYPE_CRASH : TYPE_SURGE

      priceEvent = createPriceEvent(
        state,
        getPriceEventForCrop(cropItem),
        priceEventType
      )

      newDayNotifications.push(
        priceEventType === TYPE_CRASH
          ? {
              message: PRICE_CRASH('', cropItem),
              severity: 'warning',
            }
          : {
              message: PRICE_SURGE('', cropItem),
              severity: 'success',
            }
      )
    }
  }

  return { ...state, ...priceEvent, newDayNotifications }
}
